import React, { useState } from "react";

import { proper } from "lib/common";

import {
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import {
  Button,
  Dropdown,
  RemovableList,
  TextArea,
  ButtonLike,
  DisLikeIcon,
  LikeIcon,
} from "@atsent/components";

import { startDemo, voteDemo } from "lib/store/sentiment";
import { asyncGetProject, currentProject } from "lib/store/project";
import { errorToastState } from "lib/store/common";

import { ResultTable } from "components/atom/ResultTable";

import "./Demo.scss";

export type ProductDemoProps = {
  cx?: string;
};

const Step0 = ({
  textArea,
  setStep,
  setResult,
}: {
  textArea: any;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setResult: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const pid = useRecoilValue(currentProject);
  const setErrorToast = useSetRecoilState(errorToastState);
  return (
    <>
      <span className={"title"}>요소 기반 감성 분석</span>
      <div className={"span-with-dropdown"}>
        <span className={"number"}>감정 분석을 할 구문을 입력 해 보세요.</span>
        <Dropdown change={() => null} opt={[{ value: "ko", text: "한국어" }]} />
      </div>
      <TextArea count={textArea} max={1000} hasCount />
      <Button
        click={async () => {
          try {
            const { result, id } = await startDemo(pid, { text: textArea[0] });
            await setResult({ result, id });
            await setStep(1);
          } catch (e) {
            setErrorToast(e);
          }
        }}
        cx={"black"}
        disabled={textArea[0].length === 0}
        isNext
      >
        <span> 감성 분석</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m18.5 18 2.5-3m0 0-2.5-3m2.5 3H9"
            stroke="#fff"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      </Button>
    </>
  );
};

const Step1 = ({
  result,
  textArea,
  setStep,
  id,
}: {
  result: any;
  textArea: any;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  id: number;
}) => {
  const pid = useRecoilValue(currentProject);
  const project = useRecoilValueLoadable(asyncGetProject);
  const [end, setEnd] = useState(false);
  const [text, setText] = textArea;
  return (
    <>
      <div className={"span-with-dropdown"}>
        <span className={"number"}>분석 구문</span>
        <span>{proper(project.contents.category)}</span>
      </div>
      <RemovableList
        list={[{ text }]}
        click={() => {
          setText("");
          setStep(0);
        }}
      />
      <div className={"result-title"}>
        <span>분석 결과</span>
        <div className="right">
          <form
            className={`button-wrapper ${end}`}
            onChange={async (e: any) => {
              await setEnd(true);
              await voteDemo(pid, id, e.target.value);
            }}
          >
            <label>
              <input type="radio" value={0} name={"result"} disabled={end} />
              <ButtonLike outline>
                <DisLikeIcon />
                <span>아닌 것 같아요</span>
              </ButtonLike>
            </label>
            <label>
              <input type="radio" value={1} name={"result"} disabled={end} />
              <ButtonLike outline>
                <LikeIcon /> <span>좋아요</span>
              </ButtonLike>
            </label>
          </form>
          <div className={`thanks ${end}`}>평가해주셔서 감사합니다!</div>
        </div>
      </div>
      <ResultTable result={result} />
    </>
  );
};

export const Demo: React.FC<ProductDemoProps> = ({ cx = "" }) => {
  const textArea = useState("");
  const [step, setStep] = useState(0);
  const [result, setResult] = useState({
    result: {
      aspect: "",
      aspect_score: 0,
      sentiment: "",
      sentiment_score: 0,
    },
    id: 0,
  });

  window.history.pushState(
    "",
    "",
    "/" + window.location.pathname.split("/")[1] + "/demo"
  );
  return (
    <section className={`Demo ${cx}`}>
      {step === 0 ? (
        <Step0 setStep={setStep} setResult={setResult} textArea={textArea} />
      ) : (
        <Step1
          setStep={setStep}
          result={result.result}
          id={result.id}
          textArea={textArea}
        />
      )}
    </section>
  );
};
